// 是否vn mart，具体定义请见 https://confluence.shopee.io/pages/viewpage.action?pageId=1645022784

import { AppCountry } from "@/constants/app.constant"

// TODO: foodyServiceId有哪些可选值，以及每个值对应的含义目前未知，需整理到枚举方便复用
export const isMart = (foodyServiceId: number) => {
  return AppCountry.isVn && [4, 5, 6, 7, 12, 13].includes(foodyServiceId)
}
